import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useTranslate } from "react-polyglot";
import { useBaseData } from "../../../../Providers/Data/BaseDataProvider.jsx";

/**
 * Сообщает об отсутствии доступных уровней в загруженном курсе.
 *
 * @returns {React.ReactElement|null} Сообщение для пустого списка уровней.
 */
const EmptyLevelsMessage = () => {
  const { levelsAndReward } = useBaseData();
  const t = useTranslate();

  if (levelsAndReward?.levels?.length !== 0) return null;

  return (
    <Box maxWidth={532} mx="auto" py={4} px={2}>
      <Typography align="center" color="textSecondary" role="status">
        {t("Levels.empty")}
      </Typography>
    </Box>
  );
};

export default EmptyLevelsMessage;
